import Joi from "joi-browser";
import {
  calculateTerm
} from "../libs/blackscholes";

export function getBSConfig() {
    return {
        scope: "company",
        empty: {
            stockPrice: 0,
            volatility: 55,
            rows: [{
                    id: "6 Months",
                    stock_price: 0,
                    exercise_price: 0,
                    termInDays: 0,
                    term: 0,
                    volatility: 55,
                    arqd: 0,
                    discount_rate: 2.05,
                },
                {
                    id: "12 Months",
                    stock_price: 0,
                    exercise_price: 0,
                    termInDays: 0,
                    term: 0,
                    volatility: 55,
                    arqd: 0,
                    discount_rate: 2.26,
                },
                {
                    id: "18 Months",
                    stock_price: 0,
                    exercise_price: 0,
                    termInDays: 0,
                    term: 0,
                    volatility: 55,
                    arqd: 0,
                    discount_rate: 2.38,
                },
                {
                    id: "24 Months",
                    stock_price: 0,
                    exercise_price: 0,
                    termInDays: 0,
                    term: 0,
                    volatility: 55,
                    arqd: 0,
                    discount_rate: 2.50,
                },
            ]
        },
        fieldTypes: {
            stockPrice: {
                fieldName: "stockPrice"
            },
            volatility: {
                fieldName: "volatility"
            }
        },
        validationSchema: Joi.object().keys({
            rows: Joi.array(),
            stockPrice: Joi.number().required().min(0),
            volatility: Joi.number().required().min(0).max(100),
        })
    };
}